import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import CarouselBlog from './CarouselBlog';

import api from '../services/api';
import './BlogListv.css';
import banner11 from '../images/banner11.webp';
import { FiClock, FiCalendar, FiBookmark, FiShare2, FiHeart } from 'react-icons/fi';

const BlogList = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [isLoading, setIsLoading] = useState(false);
  const [allPosts, setAllPosts] = useState([]); // Store all posts
  const [displayedPosts, setDisplayedPosts] = useState([]); // Posts to display
  const [error, setError] = useState(null);
  const [sidebarSticky, setSidebarSticky] = useState(false);
  const [readingTime, setReadingTime] = useState({});

  useEffect(() => {
    const fetchPosts = async () => {
      setIsLoading(true);
      try {
        const data = await api.get('/blogs');
        setAllPosts(data);
        setDisplayedPosts(data);

        // Calculate reading time for each post
        const timeData = {};
        data.forEach(post => {
          timeData[post.id] = calculateReadingTime(post.content);
        });
        setReadingTime(timeData);

        setIsLoading(false);
      } catch (err) {
        setError(err.message);
        setIsLoading(false);
      }
    };

    fetchPosts();

    // Add scroll event listener for sticky sidebar
    const handleScroll = () => {
      setSidebarSticky(window.scrollY > 200);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const calculateReadingTime = (content) => {
    const wordsPerMinute = 200;
    const wordCount = content.split(/\s+/).length;
    return Math.ceil(wordCount / wordsPerMinute);
  };

  const categories = ['all', ...new Set(allPosts.map(post => post.category))];

  const handleCategoryChange = (category) => {
    setIsLoading(true);
    setActiveCategory(category);

    setTimeout(() => {
      const filtered = category === 'all'
        ? allPosts
        : allPosts.filter(post => post.category === category);
      setDisplayedPosts(filtered);
      setIsLoading(false);
    }, 300);
  };

  const formatDate = (dateString) => {
    try {
      // Use created_at from the database
      const date = dateString ? new Date(dateString) : new Date();
      if (isNaN(date.getTime())) {
        return 'Date not available';
      }
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch (e) {
      console.error('Error formatting date:', e);
      return 'Date not available';
    }
  };

  if (error) return <div className="errorv">Error: {error}</div>;

  return (
    <>
      <div className="blog-containerv">
        {/* Category Filters - Mobile */}
        <div className="category-filters-mobilev">
          <select
            value={activeCategory}
            onChange={(e) => handleCategoryChange(e.target.value)}
            className="category-selectv"
            disabled={isLoading}
          >
            {categories.map(category => (
              <option key={category} value={category}>
                {category.charAt(0).toUpperCase() + category.slice(1)}
              </option>
            ))}
          </select>
        </div>

        <div className="blog-layoutv">
          {/* Main Content */}
          <main className="blog-mainv">
            {/* Featured Post - Only show if posts exist */}
            {displayedPosts.length > 0 && (
              <div className="featured-postv">
                <div className="featured-imagev">
                  <img
                    src={displayedPosts[0].image_url || banner11}
                    alt={displayedPosts[0].title}
                    loading="lazy"
                  />
                  <div className="featured-badgev">Featured</div>
                </div>
                <div className="featured-contentv">
                  <div className="post-metav">
                    <span className="post-categoryv">{displayedPosts[0].category || 'Uncategorized'}</span>
                    <span className="post-datev">
                      <FiCalendar /> {formatDate(displayedPosts[0].created_at)}
                    </span>
                  </div>
                  <h2>{displayedPosts[0].title}</h2>
                  <p className="post-excerptv">
                    {displayedPosts[0].excerpt ||
                      (displayedPosts[0].content
                        ? displayedPosts[0].content.replace(/<[^>]*>/g, '').substring(0, 200) + '...'
                        : 'No content available')}
                  </p>
                  <Link to={`/blog/${displayedPosts[0].id}`} className="read-morev">
                    Continue Reading →
                  </Link>
                </div>
              </div>
            )}

            {/* Loading State */}
            {isLoading && (
              <div className="loading-overlayv">
                <div className="loading-spinnerv"></div>
              </div>
            )}

            {/* Blog Posts Grid */}
            <div className="posts-gridv">
              {displayedPosts.slice(1).map(post => (
                <article key={post.id} className="post-cardv">
                  <Link to={`/blog/${post.id}`} className="post-image-linkv">
                    <div className="post-imagev">
                      <img
                        src={post.image_url || banner11}
                        alt={post.title}
                        loading="lazy"
                      />
                      <div className="image-overlayv"></div>
                    </div>
                  </Link>
                  <div className="post-contentv">
                    <div className="post-metav">
                      <span className="post-categoryv">{post.category || 'Uncategorized'}</span>
                      <span className="post-datev">
                        <FiCalendar /> {formatDate(post.created_at)}
                      </span>
                    </div>
                    <h3>{post.title}</h3>
                    <p className="post-excerptv">
                      {post.excerpt ||
                        (post.content
                          ? post.content.replace(/<[^>]*>/g, '').substring(0, 150) + '...'
                          : 'No content available')}
                    </p>
                    {/* {readingTime[post.id] && (
                      <div className="post-reading-timev">
                        <FiClock /> {readingTime[post.id]} min read
                      </div>
                    )} */}
                  </div>
                </article>
              ))}
            </div>

            {/* Empty State */}
            {!isLoading && displayedPosts.length === 0 && (
              <div className="empty-statev">
                <h3>No posts found</h3>
                <p>Try selecting a different category or check back later.</p>
              </div>
            )}
          </main>

          {/* Sidebar */}
          <aside className={`blog-sidebarv ${sidebarSticky ? 'stickyv' : ''}`}>
            {/* Categories Card */}
            <div className="sidebar-cardv categories-cardv">
              <h3 className="card-titlev">Categories</h3>
              <div className="category-listv">
                {categories.filter(cat => cat !== 'all').map(category => (
                  <button
                    key={category}
                    className={`category-itemv ${activeCategory === category ? 'activev' : ''}`}
                    onClick={() => handleCategoryChange(category)}
                    disabled={isLoading}
                  >
                    <span className="category-namev">
                      {category.charAt(0).toUpperCase() + category.slice(1)}
                    </span>
                    <span className="category-countv">
                      ({allPosts.filter(post => post.category === category).length})
                    </span>
                  </button>
                ))}
              </div>
            </div>

            {/* Popular Posts Card */}
            <div className="sidebar-cardv popular-postsv">
              <h3 className="card-titlev">Other Posts</h3>
              {displayedPosts.slice(0, 3).map(post => (
                <div key={`popular-${post.id}`} className="popular-postv">
                  <Link to={`/blog/${post.id}`} className="popular-post-linkv">
                    <div className="popular-post-imagev">
                      <img
                        src={post.image_url || banner11}
                        alt={post.title}
                        loading="lazy"
                      />
                    </div>
                    <div className="popular-post-contentv">
                      <h4>{post.title}</h4>
                      <span className="post-datev">
                        <FiCalendar /> {formatDate(post.created_at)}
                      </span>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </aside>
        </div>
      </div>
    </>
  );
};

export default BlogList;